module.exports = __webpack_public_path__ + "img/get_coupon_bg@2x.dd5f28a7.png";